namespace RioERP.Orders {
    export interface OrderBrandAmbassadorShareForm {
        OrderId: Serenity.IntegerEditor;
        BrandAmbassadorId: Serenity.IntegerEditor;
        SharePercentage: Serenity.DecimalEditor;
        OrderGrossAmount: Serenity.DecimalEditor;
        ShareAmount: Serenity.DecimalEditor;
        SettelmentId: Serenity.IntegerEditor;
        ESettelementStatus: Serenity.EnumEditor;
        IsActive: Serenity.BooleanEditor;
        InsertUserId: Serenity.IntegerEditor;
        InsertDate: Serenity.DateEditor;
        UpdateUserId: Serenity.IntegerEditor;
        UpdateDate: Serenity.DateEditor;
    }

    export class OrderBrandAmbassadorShareForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.OrderBrandAmbassadorShare';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderBrandAmbassadorShareForm.init)  {
                OrderBrandAmbassadorShareForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.EnumEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.DateEditor;

                Q.initFormType(OrderBrandAmbassadorShareForm, [
                    'OrderId', w0,
                    'BrandAmbassadorId', w0,
                    'SharePercentage', w1,
                    'OrderGrossAmount', w1,
                    'ShareAmount', w1,
                    'SettelmentId', w0,
                    'ESettelementStatus', w2,
                    'IsActive', w3,
                    'InsertUserId', w0,
                    'InsertDate', w4,
                    'UpdateUserId', w0,
                    'UpdateDate', w4
                ]);
            }
        }
    }
}
